import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sendOtpRegister, verifyOtpAndRegister, messageClear } from "../store/reducers/authReducer";
import toast from "react-hot-toast";
import { FadeLoader } from "react-spinners";
import { Mail, Phone, ShieldCheck } from "lucide-react";

const VerifyOtp = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loader, successMessage, errorMessage } = useSelector((state) => state.auth);

  const { name, email, phone, password } = location.state || {};
  const [otpEmail, setOtpEmail] = useState("");
  const [otpPhone, setOtpPhone] = useState("");
  const [emailOtpSent, setEmailOtpSent] = useState(false);
  const [phoneOtpSent, setPhoneOtpSent] = useState(false);

  const sendEmailOtp = () => {
    dispatch(sendOtpRegister({ type: "email", email }))
      .unwrap()
      .then(() => setEmailOtpSent(true))
      .catch((err) => {
      toast.error(err.error || "Failed to send email OTP");
    });
  };

  const sendPhoneOtp = () => {
    dispatch(sendOtpRegister({ type: "phone", phone }))
      .unwrap()
      .then(() => setPhoneOtpSent(true))
      .catch((err) => {
      toast.error(err.error || "Failed to send phone OTP");
    });
  };

  const verifyOtp = (e) => {
    e.preventDefault();
    dispatch(
      verifyOtpAndRegister({
        name,
        email,
        phone,
        password,
        emailOtp: otpEmail,
        phoneOtp: otpPhone,
      })
    )
      .unwrap()
      .then(() => {
        navigate("/"); // Redirect after success
      });
  };

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
  }, [successMessage, errorMessage, dispatch]);

  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-gradient-to-r from-green-50 to-blue-50">
      {loader && (
        <div className="absolute inset-0 flex justify-center items-center bg-[#38303033] z-[999]">
          <FadeLoader />
        </div>
      )}

      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-[420px]">
        {/* Header */}
        <div className="flex flex-col items-center mb-6">
          <ShieldCheck className="w-12 h-12 text-green-600 mb-2" />
          <h2 className="text-2xl font-bold text-gray-700">
            Verify Your Account
          </h2>
          <p className="text-gray-500 text-sm text-center mt-1">
            Please confirm your email and phone with OTPs
          </p>
        </div>

        {/* Email OTP Section */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <Mail className="w-5 h-5 text-blue-500" />
            <p className="text-sm text-gray-700">
              Email: <b>{email}</b>
            </p>
          </div>
          {!emailOtpSent ? (
            <button
              onClick={sendEmailOtp}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white py-2 rounded-md shadow-md"
            >
              Send Email OTP
            </button>
          ) : (
            <input
              value={otpEmail}
              onChange={(e) => setOtpEmail(e.target.value)}
              placeholder="Enter Email OTP"
              className="w-full mt-2 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          )}
        </div>

        {/* Phone OTP Section */}
        <div className="mb-6">
          <div className="flex items-center gap-2 mb-2">
            <Phone className="w-5 h-5 text-green-500" />
            <p className="text-sm text-gray-700">
              Phone: <b>{phone}</b>
            </p>
          </div>
          {!phoneOtpSent ? (
            <button
              onClick={sendPhoneOtp}
              className="w-full bg-green-500 hover:bg-green-600 text-white py-2 rounded-md shadow-md"
            >
              Send Phone OTP
            </button>
          ) : (
            <input
              value={otpPhone}
              onChange={(e) => setOtpPhone(e.target.value)}
              placeholder="Enter Phone OTP"
              className="w-full mt-2 px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-400"
            />
          )}
        </div>

        {/* Verify Button */}
        <button
          onClick={verifyOtp}
          className="w-full py-2 bg-gradient-to-r from-green-500 to-blue-500 text-white font-semibold rounded-lg shadow-md hover:opacity-90 transition"
        >
          Verify & Register
        </button>
      </div>
    </div>
  );
};

export default VerifyOtp;
